import { render, staticRenderFns } from "./ServerMessage.vue?vue&type=template&id=71b6b926"
import script from "./ServerMessage.vue?vue&type=script&lang=js"
export * from "./ServerMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports